var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-0 position-relative"},[_c('span',{staticClass:"font-weight-bold title-line"},[_vm._v(_vm._s(_vm.text))]),(_vm.isLine)?_c('div',{staticClass:"line"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }